import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";


import { UserContext } from "../../UserContext";

import iconPsicoterapia from "../../assets/images/servicos/icon_psicoterapia.png";
import iconPsicopedagogia from "../../assets/images/servicos/icon_psicopedagogia.png";
import iconPediatria from "../../assets/images/servicos/icon_pediatria.png";
import iconNutricao from "../../assets/images/servicos/icon_nutricao.png";
import iconFisioterapia from "../../assets/images/servicos/icon_fisioterapia.png";
import iconNeuropsicologia from "../../assets/images/servicos/icon_neuropsicologia.png";


const Home = () => {

    var settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
    };
   
  const imagefirst = {
    width: '100%',
    height: '610',
    maxWidth: '1920px',
    margin: '0',
  };

 

  return (
    <div id="main">
      <div className="slider-container">
        <Slider {...settings}>
          <div>
            <picture>
              <source media="(max-width:750px)" srcSet="https://firebasestorage.googleapis.com/v0/b/psicologia-6d3e3.appspot.com/o/site%2Fimagens%2Fbanner%2Fbanner01-mobile.webp?alt=media&token=9d9203c5-1338-469a-929f-3bdf8b97f199" />
              <source media="(max-width:465px)" srcSet="https://firebasestorage.googleapis.com/v0/b/psicologia-6d3e3.appspot.com/o/site%2Fimagens%2Fbanner%2Fbanner01-mobile.webp?alt=media&token=9d9203c5-1338-469a-929f-3bdf8b97f199" />
              <img src="https://firebasestorage.googleapis.com/v0/b/psicologia-6d3e3.appspot.com/o/site%2Fimagens%2Fbanner%2Fbanner01-desktop.webp?alt=media&token=914665b1-c959-473c-a18f-cc3badab9c6c" alt="Banner 1" />
            </picture>
          </div>
          <div>
            <picture>
              <source media="(max-width:750px)" srcSet="https://firebasestorage.googleapis.com/v0/b/psicologia-6d3e3.appspot.com/o/site%2Fimagens%2Fbanner%2Fbanner02-mobile.webp?alt=media&token=09cf8712-259e-4c12-94f8-007cffd15ba0" />
              <source media="(max-width:465px)" srcSet="https://firebasestorage.googleapis.com/v0/b/psicologia-6d3e3.appspot.com/o/site%2Fimagens%2Fbanner%2Fbanner02-mobile.webp?alt=media&token=09cf8712-259e-4c12-94f8-007cffd15ba0" />
              <img src="https://firebasestorage.googleapis.com/v0/b/psicologia-6d3e3.appspot.com/o/site%2Fimagens%2Fbanner%2Fbanner02-desktop.webp?alt=media&token=b935f78b-a432-4a99-84b3-f259931c5d09" alt="Banner 2" />
            </picture>
          </div>
        </Slider>
      </div>

      <section id="primary" className="content-full-width">
        <div className="container">
          <div className="dt-sc-one-third column first">
            <div className="dt-sc-ico-content type1">
              <div className="icon">
                <span className="icon-outer">
                  <img src={iconPsicoterapia} alt="Psicoterapia" />
                  <span className="infolayer">
                    <a href="/psicologia-infantil"><i className="fa fa-link"></i></a>
                  </span>
                </span>
              </div>
              <h4><a href="/psicologia-infantil">Psicoterapia</a></h4>
              <p className="teste">A psicoterapia infantil busca auxiliar a criança a expressar suas emoções, lidar com conflitos e promover um desenvolvimento emocional saudável através do brincar e do diálogo.</p>
            </div>
          </div>
          <div className="dt-sc-one-third column">
            <div className="dt-sc-ico-content type1">
              <div className="icon">
                <span className="icon-outer">
                  <img src={iconPsicopedagogia} alt="Psicopedagogia" />
                  <span className="infolayer">
                    <a href="/psicopedagogia"><i className="fa fa-link"></i></a>
                  </span>
                </span>
              </div>
              <h4><a href="/psicopedagogia">Psicopedagogia</a></h4>
              <p>é uma area que se dedica a estudar o processo de aprendizagem e a tratar problemas de aprendizagem e comportamento.</p>
            </div>
          </div>
          <div className="dt-sc-one-third column">
            <div className="dt-sc-ico-content type1">
              <div className="icon">
                <span className="icon-outer">
                  <img src={iconPediatria} alt="Pediatria" />
                  <span className="infolayer">
                    <a href="/pediatra"><i className="fa fa-link"></i></a>
                  </span>
                </span>
              </div>
              <h4><a href="/pediatra">Pediatria</a></h4>
              <p>Médica Pediatra é a responsável por cuidar da saúde das crianças e dos adolescentes.</p>
            </div>
          </div>
          <div className="dt-sc-one-third column first" style={{ clear: 'both' }}>
            <div className="dt-sc-ico-content type1">
              <div className="icon">
                <span className="icon-outer">
                  <img src={iconNutricao} alt="Nutrição" />
                  <span className="infolayer">
                    <a href="/nutricionista"><i className="fa fa-link"></i></a>
                  </span>
                </span>
              </div>
              <h4><a href="/nutricionista">Nutrição</a></h4>
              <p>O nutricionista infantil é um profissional que ajudará as familias a ajustarem habitos alimentares e a melgorarem as suas praticas.</p>
            </div>
          </div>
          <div className="dt-sc-one-third column">
            <div className="dt-sc-ico-content type1">
              <div className="icon">
                <span className="icon-outer">
                  <img src={iconFisioterapia} alt="Fisioterapia" />
                  <span className="infolayer">
                    <a href="/fisioterapia"><i className="fa fa-link"></i></a>
                  </span>
                </span>
              </div>
              <h4><a href="/fisioterapia">Fisioterapia</a></h4>
              <p>A fisioterapia focada na infância tem por objetivo melhorar o bem estar fisico da criança.</p>
            </div>
          </div>
          <div className="dt-sc-one-third column">
            <div className="dt-sc-ico-content type1">
              <div className="icon">
                <span className="icon-outer">
                  <img src={iconNeuropsicologia} alt="Avaliação Neuropsicologica" />
                  <span className="infolayer">
                    <a href="/avaliacao-neuropsicologica"><i className="fa fa-link"></i></a>
                  </span>
                </span>
              </div>
              <h4><a href="/avaliacao-neuropsicologica">Avaliação Neuropsicologica</a></h4>
              <p>é uma avaliação  que analisa o funcionamento cognitivo e comportamental da criança.</p>
            </div>
          </div>
        </div>

        <div className="dt-sc-hr"></div>

      </section>
    </div>
  );
};

export default Home;
